<div class="forgot-password-container">
  <app-card>
    <div class="forgot-password-content">
      <!-- Form View -->
      <ng-container *transloco="let t">
        <ng-container *ngIf="!isSuccess">
          <h1 class="title">{{ t('auth.forgotPassword.title') }}</h1>
          <p class="subtitle">{{ t('auth.forgotPassword.subtitle') }}</p>

          <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="form">
            <app-input
              [label]="t('auth.forgotPassword.emailLabel')"
              [placeholder]="t('auth.forgotPassword.emailPlaceholder')"
              formControlName="email"
              type="email"
              [required]="true"
              [error]="
                forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched
                  ? forgotPasswordForm.get('email')?.hasError('required')
                    ? t('auth.validation.required')
                    : t('auth.validation.invalidEmail')
                  : ''
              "></app-input>

            <div *ngIf="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>

            <app-button [block]="true" type="submit" [disabled]="forgotPasswordForm.invalid || isSubmitting" [fullWidth]="true">
              {{ isSubmitting ? t('auth.common.loading') : t('auth.forgotPassword.resetButton') }}
            </app-button>
          </form>

          <div class="login-link">
            <span>{{ t('auth.forgotPassword.rememberPassword') }}</span>
            <a href="{{ languageRoutingService.getLocalizedRoute('/login') }}">{{ t('auth.forgotPassword.signIn') }}</a>
          </div>
        </ng-container>

        <!-- Success View -->
        <ng-container *ngIf="isSuccess">
          <div class="success-container">
            <h1 class="title">{{ t('auth.forgotPassword.successTitle') }}</h1>
            <p class="success-message">
              {{ t('auth.forgotPassword.successMessage') }}
            </p>
            <app-button type="button" [fullWidth]="true" [routerLink]="languageRoutingService.getLocalizedRoute('/login')">
              {{ t('auth.forgotPassword.backToLogin') }}
            </app-button>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </app-card>
</div>
